/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList, agentLimits }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
      agent_limits: agentLimits,
    });
  }
}

export default new InboxMembers();
